const letters = [
  { char: 'G', color: '#4285F4' },
  { char: 'o', color: '#EA4335' },
  { char: 'o', color: '#FBBC05' },
  { char: 'g', color: '#4285F4' },
  { char: 'l', color: '#34A853' },
  { char: 'e', color: '#EA4335' },
];

export default function GoogleWordmark({ className = '' }: { className?: string }) {
  return (
    <span
      className={`font-label font-semibold tracking-tight ${className}`}
      aria-label="Google"
      role="img"
    >
      {letters.map((l, i) => (
        <span key={`${l.char}-${i}`} style={{ color: l.color }}>
          {l.char}
        </span>
      ))}
    </span>
  );
}